import {
  ServiceRequestSelectionCardView,
  H2,
  Overline,
  colorsLight,
  H5,
  useGetServiceRequestByIdWithFallback,
} from "@coherehealth/common";
import { CircularProgress, Dialog, IconButton } from "@mui/material";
import config from "api/config";
import { styled } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";

interface SelectAServiceRequestCardProps {
  srId: string;
  serviceCaseId: string;
}

function SelectAServiceRequestCard({ srId, serviceCaseId }: SelectAServiceRequestCardProps) {
  const { data, loading, error } = useGetServiceRequestByIdWithFallback({
    id: srId,
    base: `${config.SERVICE_API_URL}`,
  });

  if (loading) {
    return <CircularProgress size={20} />;
  } else if (error) {
    return <H5>Could not load service request</H5>;
  } else {
    return (
      <ServiceRequestSelectionCardView serviceRequest={data} serviceCaseId={serviceCaseId} showEditRequest={false} />
    );
  }
}

interface SelectAServiceRequestModalProps {
  dialogOpen: boolean;
  onClose: () => void;
  serviceRequestIds?: string[];
  serviceCaseId: string;
}

export default function SelectAServiceRequestModal({
  dialogOpen,
  onClose,
  serviceRequestIds,
  serviceCaseId,
}: SelectAServiceRequestModalProps) {
  return (
    <Dialog open={dialogOpen} onClose={onClose} PaperProps={{ sx: { borderRadius: 4 } }}>
      <HeaderContainer>
        <Header>Select a service request associated with this Case ID</Header>
        <IconButton
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: colorsLight.font.secondary,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </HeaderContainer>
      <CardSection>
        <ResultText>{serviceRequestIds?.length || 0} RESULTS:</ResultText>
        {serviceRequestIds &&
          serviceRequestIds.map((srId) => (
            <CardContainer key={srId}>
              <SelectAServiceRequestCard srId={srId} serviceCaseId={serviceCaseId} />
            </CardContainer>
          ))}
      </CardSection>
    </Dialog>
  );
}

const HeaderContainer = styled("div")({
  boxShadow: "0px 4px 8px rgba(33, 41, 54, 0.1)",
  zIndex: 1,
  borderBottomColor: colorsLight.gray.divider,
  borderBottomStyle: "solid",
});

const CardContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

const CardSection = styled("div")(({ theme }) => ({
  backgroundColor: colorsLight.background.mid,
  padding: theme.spacing(3, 3, 4.5),
  maxHeight: 760,
  overflow: "scroll",
}));

const Header = styled(H2)(({ theme }) => ({
  margin: theme.spacing(10, 7, 7),
  textAlign: "center",
}));

const ResultText = styled(Overline)({
  color: colorsLight.font.secondary,
});
